import {
  CancellationFlowStatus,
  getCancellationFlowStatusClass,
  getCancellationFlowStatusLabel,
} from './cancellation-flow-status.enum';

/** A timeline row that edited the cancellation's fields rather than moving its status. */
export const CANCELLATION_HISTORY_UPDATED = 'UPDATED';

/** A timeline row that soft-deleted the cancellation. */
export const CANCELLATION_HISTORY_DELETED = 'DELETED';

/**
 * What a row of a cancellation's timeline records: a period spent in one of
 * the flow's statuses, an `UPDATED` edit of its fields or its `DELETED`
 * soft-deletion — both instantaneous, and never the flow's own status.
 */
export type CancellationFlowHistoryStatus =
  | CancellationFlowStatus
  | typeof CANCELLATION_HISTORY_UPDATED
  | typeof CANCELLATION_HISTORY_DELETED;

export const getCancellationFlowHistoryLabel = (
  status: CancellationFlowHistoryStatus
): string => {
  switch (status) {
    case CANCELLATION_HISTORY_UPDATED:
      return $localize`Modification`;
    case CANCELLATION_HISTORY_DELETED:
      return $localize`Supprimée`;
    default:
      return getCancellationFlowStatusLabel(status);
  }
};

export const getCancellationFlowHistoryStatusClass = (
  status: CancellationFlowHistoryStatus
): string => {
  switch (status) {
    case CANCELLATION_HISTORY_UPDATED:
      return 'gray';
    case CANCELLATION_HISTORY_DELETED:
      return 'danger';
    default:
      return getCancellationFlowStatusClass(status);
  }
};
